export function getShowLoader({ utilsReducer }) {
  if (utilsReducer && utilsReducer.showLoader) return utilsReducer.showLoader;
  else return false;
}
